<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'
  import { mapState } from 'vuex'

  export default {
    name: 'Qr',

    metaInfo () { return { title: `${this.vibeUser?.firstName || 'Qr'}` } },

    extends: View,

    mixins: [
      LoadSections(['qr']),
    ],

    props: {
      id: {
        type: String,
        default: 'qr',
      },
    },

    computed: {
      ...mapState('app', ['vibeUser']),
    },
  }
</script>
